import { type ContentComponent, type StoreHoursPlaceholderContent } from '../../../../types/construct.types';
import { ContactHours } from '../../../support-components/contact-hours/contact-hours.component';

export const StoreHoursPlaceholder: ContentComponent<StoreHoursPlaceholderContent> = () => <ContactHours />;
